import React from "react";
import { Modal, Button } from "react-bootstrap";

const SaveSettingsModal = ({ show, onHide, isActive, onTurnOn }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="cbs-save-modal-wrapper"
    >
      <Modal.Body className="pt-0 pb-2">
        <Modal.Header className="modal-title-with-border mb-0" closeButton>
          <Modal.Title>
            {isActive ? "Settings Updated" : "Settings Saved"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {isActive ? (
            <div>
              <p>
                Your changes are now <strong>Active</strong>. New clients will
                see your updated availability and rules.
              </p>
              <p className="mb-0">
                <strong>Note</strong>: Existing bookings are not affected. Jobs
                already on your calendar remain unchanged.
              </p>
            </div>
          ) : (
            <div>
              <p className="mb-0">
                Your configuration has been updated successfully.
              </p>
              <p className="mb-0">
                <strong>Note</strong>: Client booking is currently Inactive. You
                must <strong>Turn On</strong> to start receiving bookings.
              </p>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="mt-0">
          {!isActive && (
            <Button
              variant="outline-primary"
              onClick={() => {
                onHide();
                onTurnOn();
              }}
            >
              Turn On Now
            </Button>
          )}
          <Button variant="primary" onClick={onHide}>
            Got it
          </Button>
        </Modal.Footer>
      </Modal.Body>
    </Modal>
  );
};

export default SaveSettingsModal;
